import { useMediaQuery } from '@mui/material'
import {
  FunctionComponent,
  ReactNode,
  createContext,
  useContext,
  useEffect,
  useState
} from 'react'

interface GetAppContext {
  show: boolean
  IgnorePrompt: () => void
}

const getAppContext = createContext<GetAppContext>({
  show: false,
  IgnorePrompt: () => {
    throw new Error('setIgnored not implemented')
  }
})

export const GetAppProvider: FunctionComponent<{ children: ReactNode }> = ({
  children
}) => {
  const [show, setShow] = useState<boolean>(false)
  const [ignored, setIgnored] = useState<boolean>(false)
  const isMobile = useMediaQuery('(max-width: 900px)')
  useEffect(() => {
    if (!ignored && isMobile) setShow(true)
    else setShow(false)
  }, [ignored, isMobile])

  const IgnorePrompt = (): void => {
    setIgnored(true)
    setShow(false)
  }

  return (
    <getAppContext.Provider
      value={{
        show,
        IgnorePrompt
      }}
    >
      {children}
    </getAppContext.Provider>
  )
}

export const useGetAppContext = (): GetAppContext => {
  return useContext(getAppContext)
}
